import Vue from "vue";
import Vuetify from "vuetify";
import "vuetify/dist/vuetify.min.css";


Vue.use(Vuetify)

const opts = {
    buttons: {
        capitalize: false,
    },
    options: {
        customProperties: true,
    },
    themes: {
        light: {
            primary: "#4c1a65",
        },
    },
}

export default new Vuetify({
    opts,
})